import { selectSearchExecutionResult } from 'views/logic/slices/searchExecutionSelectors';
import useAppSelector from 'stores/useAppSelector';

const useSearchResult = () => useAppSelector(selectSearchExecutionResult);
export default useSearchResult;
